<script setup>
const props = defineProps({
  orderNo: {
    type: String,
    required: true,
  },
  orderAmount: {
    type: String,
    required: true,
  },
  commissionRate: {
    type: String,
    required: true,
  },
  commissionAmount: {
    type: String,
    required: true,
  },
});

const formatToPercent = value => {
  return value ? `${value}%` : '--';
};
</script>

<template>
  <div
    class="grid items-center content-center w-full h-16 grid-cols-12 gap-4 px-6 py-0 border-b last:border-b-0 last:rounded-b-xl border-n-weak"
  >
    <!-- Order No -->
    <div
      class="flex items-center gap-2 col-span-3 px-0 py-2 text-sm tracking-[0.5] text-slate-700 dark:text-slate-100 rtl:text-right"
    >
      {{ `#${orderNo} ` }}
    </div>

    <!-- Order Amount -->
    <div
      class="flex items-center capitalize py-2 px-0 text-sm tracking-[0.5] text-slate-700 dark:text-slate-50 text-left rtl:text-right col-span-3"
    >
      {{ orderAmount }}
    </div>

    <!-- Commission Rate -->
    <div
      class="flex items-center capitalize py-2 px-0 text-sm tracking-[0.5] text-slate-700 dark:text-slate-50 text-left rtl:text-right col-span-2"
    >
      {{ formatToPercent(commissionRate) }}
    </div>

    <!-- Commission Amount -->
    <div
      class="flex items-center capitalize py-2 px-0 text-sm tracking-[0.5] text-slate-700 dark:text-slate-50 text-left rtl:text-right col-span-2"
    >
      {{ commissionAmount }}
    </div>

    <!-- Empty Column (Spacer or Action Buttons) -->
    <div
      class="flex items-center capitalize py-2 px-0 text-sm tracking-[0.5] text-slate-700 dark:text-slate-50 text-left rtl:text-right col-span-2"
    >
      <!-- Optional content for actions/buttons -->
    </div>
  </div>
</template>
